import axios from 'axios';

/**
 * Suscribe a un usuario a MailerLite y lo asigna al grupo correspondiente al área seleccionada
 * mediante una función serverless de Netlify (para mantener la API key segura)
 * @param {string} email - El correo electrónico del usuario
 * @param {string} name - El nombre del usuario
 * @param {string} areaId - El ID del área seleccionada (TRISTEZA, ANSIEDAD, etc.)
 * @param {number} scorePercentage - El porcentaje de la puntuación del test
 * @returns {Promise} - Promesa que resuelve cuando el usuario ha sido suscrito
 */
export const subscribeUserByArea = async (email, name, areaId, scorePercentage) => {
  try {
    // En desarrollo local (detección basada en URL)
    const isLocalDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    // URL de la función de Netlify (en local usamos puerto 8888 según netlify.toml, en producción la ruta normal)
    const functionUrl = isLocalDevelopment 
      ? 'http://localhost:8888/.netlify/functions/mailerlite-subscribe'
      : '/.netlify/functions/mailerlite-subscribe';
    
    console.log(`Llamando a la función serverless en: ${functionUrl}`);
    
    // Llamar a la función serverless de Netlify
    const response = await axios.post(functionUrl, {
      email,
      name,
      areaId,
      scorePercentage
    });
    
    console.log('Respuesta de la función serverless:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error al suscribir al usuario:', error.response?.data || error.message);
    
    // Si estamos en desarrollo local y la función no está disponible, mostrar un mensaje más claro
    if (error.message.includes('Network Error') || error.message.includes('ECONNREFUSED')) {
      console.warn('No se pudo conectar con la función serverless. Si estás en desarrollo local, asegúrate de ejecutar "netlify dev" para poder usar las funciones de Netlify.');
    }
    
    throw error;
  }
};

// Crear un objeto para la exportación en lugar de exportar un objeto anónimo
const mailerLiteService = {
  subscribeUserByArea
};

export default mailerLiteService;
